import { render, staticRenderFns } from "./AppPlaceholderSquare.vue?vue&type=template&id=2478a866&"
import script from "./AppPlaceholderSquare.vue?vue&type=script&lang=js&"
export * from "./AppPlaceholderSquare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports